/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DatasourceProcessedUntilTimestampRequest
 *
 */
// create custom validators for the regexes
export interface DatasourceProcessedUntilTimestampRequest {
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof DatasourceProcessedUntilTimestampRequest
        
    * @minimum 0
            
         */
    processedUntilTimestamp: number;
}
/**
 * Check if a given object implements the DatasourceProcessedUntilTimestampRequest interface.
 */
export function instanceOfDatasourceProcessedUntilTimestampRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "processedUntilTimestamp" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DatasourceProcessedUntilTimestampRequestTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasourceProcessedUntilTimestampRequest => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasourceProcessedUntilTimestampRequest => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.processedUntilTimestamp && 0 <= input.processedUntilTimestamp && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["processedUntilTimestamp"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceProcessedUntilTimestampRequest => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.processedUntilTimestamp && (0 <= input.processedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.processedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number",
                    value: input.processedUntilTimestamp
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["processedUntilTimestamp"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasourceProcessedUntilTimestampRequestTypiaAssertStringify = (input: DatasourceProcessedUntilTimestampRequest): string => {
    return ((input: any): string => { const assert = (input: any): DatasourceProcessedUntilTimestampRequest => {
        const __is = (input: any): input is DatasourceProcessedUntilTimestampRequest => {
            return "object" === typeof input && null !== input && ("number" === typeof (input as any).processedUntilTimestamp && !Number.isNaN((input as any).processedUntilTimestamp) && 0 <= (input as any).processedUntilTimestamp);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceProcessedUntilTimestampRequest => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "number" === typeof input.processedUntilTimestamp && !Number.isNaN(input.processedUntilTimestamp) && (0 <= input.processedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.processedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number",
                    value: input.processedUntilTimestamp
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasourceProcessedUntilTimestampRequest): string => {
        return `{"processedUntilTimestamp":${(input as any).processedUntilTimestamp}}`;
    }; return stringify(assert(input)); })(input);
};
export const DatasourceProcessedUntilTimestampRequestValidatorShape = {
    'processedUntilTimestamp': yup.number().min(0).defined(),
};
export const DatasourceProcessedUntilTimestampRequestValidator = yup.object().shape(DatasourceProcessedUntilTimestampRequestValidatorShape);
export const DatasourceProcessedUntilTimestampRequestStringifyShapeProperties: ObjectSchema['properties'] = {
    'processedUntilTimestamp': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
};
export const DatasourceProcessedUntilTimestampRequestStringifyShape: ObjectSchema = {
    title: 'DatasourceProcessedUntilTimestampRequest Stringifier',
    type: 'object',
    properties: {
        ...DatasourceProcessedUntilTimestampRequestStringifyShapeProperties
    },
    required: [
        'processedUntilTimestamp',
    ],
};
export const DatasourceProcessedUntilTimestampRequestStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasourceProcessedUntilTimestampRequestStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasourceProcessedUntilTimestampRequestStringify: (data: DatasourceProcessedUntilTimestampRequest) => string = DatasourceProcessedUntilTimestampRequestStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasourceProcessedUntilTimestampRequestFromJSON(json: any): DatasourceProcessedUntilTimestampRequest {
    return DatasourceProcessedUntilTimestampRequestFromJSONTyped(json, false);
}
export function DatasourceProcessedUntilTimestampRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasourceProcessedUntilTimestampRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'processedUntilTimestamp': json['processedUntilTimestamp'],
    };
}
export function DatasourceProcessedUntilTimestampRequestToJSON(value?: DatasourceProcessedUntilTimestampRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'processedUntilTimestamp': value.processedUntilTimestamp,
    };
}
